

























































import { Mixins, Component } from 'vue-property-decorator';
import Table from '@/components/Table/Index.vue';
import { getModule } from 'vuex-module-decorators';
import ApiKeyModule from '@/store/modules/ApiKey';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import GeneralModule from '@/store/modules/General';

@Component({
  components: {
    Table,
  },
})
export default class TransferKey extends Mixins(ErrorHandleMixin) {
  TableHead = [
    [
      {
        text: 'No',
      },
      {
        text: 'Partner',
        attr: {
          class: 'text-left',
        },
      },
      {
        text: 'Agent',
        attr: {
          class: 'text-left',
        },
      },
      {
        text: 'Secret',
        attr: {
          class: 'text-left',
        },
      },
    ],
  ];

  ApiKeyInstance = getModule(ApiKeyModule, this.$store);

  GeneralInstance = getModule(GeneralModule, this.$store);

  searchText = '';

  editModel = {
    url: '',
    _id: '',
    partner: '',
    agent: '',
  };

  data = [];

  created() {
    this.fetchKey();
  }

  async fetchKey() {
    this.GeneralInstance.toggleLoading(true);
    const res = await this.ApiKeyInstance.FetchTransferKey();
    if (res.code) {
      this.checkError(res);
    }
    this.GeneralInstance.toggleLoading(false);
    this.data = this.ApiKeyInstance.listTransferKey;
  }

  handleSearch() {
    this.data = this.ApiKeyInstance.listTransferKey
      .filter((item) => item.agent && item.agent.includes(this.searchText.toLowerCase()));
  }

  handleEdit(item) {
    const {
      _id, url, partner, agent,
    } = item;
    this.editModel._id = _id;
    this.editModel.url = url;
    this.editModel.partner = partner;
    this.editModel.agent = agent;
  }

  handleCancel() {
    this.editModel = {
      url: '',
      _id: '',
      partner: '',
      agent: '',
    };
  }

  async handleSave() {
    const res = await this.ApiKeyInstance.UpdateTransferKey(this.editModel);
    this.checkError(res);
    await this.fetchKey();
    this.handleCancel();
  }
}
